import { CustomerSearchQueryResponse, CustomerSearchQueryResponseListResponseMessage } from '@models/ropolo';
import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import { searchCustomers } from '@services/customer';
// eslint-disable-next-line import/no-cycle
import { createAppAsyncThunk } from '../utils/reduxUtil';

export interface UserStateInterface {
  users: CustomerSearchQueryResponse[];
  loading: boolean;
}

const initialState: UserStateInterface = {
  users: [],
  loading: false,
};

interface GetUsersByPhoneNumberBody {
  phoneNumber: string;
}

const getUsersByPhoneNumber = createAppAsyncThunk<
  CustomerSearchQueryResponseListResponseMessage,
  GetUsersByPhoneNumberBody
>('uses/getUsersByPhoneNumber', async (input) => {
  const { phoneNumber } = input;
  const response = await searchCustomers({
    networkStatus: true,
    search: phoneNumber,
  });

  return response;
});

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<UserStateInterface>) => {
    builder.addCase(getUsersByPhoneNumber.pending, (state) => ({ ...state, loading: true, users: [] }));

    builder.addCase(getUsersByPhoneNumber.fulfilled, (state, action) => ({
      ...state,
      users: action.payload.data || [],
      loading: false,
    }));
  },
});

export default usersSlice;
export { getUsersByPhoneNumber };
